import React, { Component } from 'react'
import { Sidebar, Dimmer, Menu, Icon} from 'semantic-ui-react'

class SidebarLeftOverlay extends Component {
	state = { visible: false };

	static contextTypes = {
		router: () => true, // replace with PropTypes.object if you use them
	};

	componentDidMount() {
		this.unlisten = this.context.router.history.listen(() => {
			this.state.visible && this.setState({ visible: false });
		});
	}

	componentWillUnmount() {
		this.unlisten && this.unlisten();
	}

	toggleVisibility = () => this.setState({ visible: !this.state.visible })

	render() {
		const { pageContent } = this.props;
		const { visible } = this.state
		return (
			<div>
				<Menu inverted attached>
					<Menu.Item onClick={this.toggleVisibility} >
						<Icon name='bars'/>
					</Menu.Item>
					<Menu.Item className='standard-header'>
						ConFuzzled 2019
					</Menu.Item>
				</Menu>
				<Sidebar.Pushable>
					<Sidebar
						as={Menu}
						animation='overlay'
						width='thin'
						visible={visible}
						vertical
						inverted
						attached
					>
						{this.props.children}
					</Sidebar>
					<Sidebar.Pusher>
						<Dimmer.Dimmable blurring dimmed={visible} onClick={() => visible && this.toggleVisibility()}>
							<Dimmer active={visible} />
							{pageContent}
						</Dimmer.Dimmable>
					</Sidebar.Pusher>
				</Sidebar.Pushable>
			</div>
		)
	}
}

export default SidebarLeftOverlay



// WEBPACK FOOTER //
// ./src/modules/Menu/PushMenu.js